import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { GuidaConSezioni } from "@/types/kb";

/** Guida di un modulo (drawer "?"). Caricata lazy quando il drawer si apre. */
export function useGuida(modulo: string, enabled: boolean) {
  return useQuery({
    queryKey: ["kb", "guida", modulo],
    queryFn: () => apiFetch<GuidaConSezioni | null>(`/api/v1/kb/guida/${modulo}`),
    enabled,
    staleTime: 5 * 60_000,
  });
}
